import React, { useEffect } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { useTranslate } from 'react-admin'

import { grayMelange } from '../../constants/colorConstants'
import ErrorImage from '../../images/error'
import PaymentEmptyImage from '../../images/paymentEmptyImage'

const useStyles = makeStyles((theme) => ({
  emptyPanel: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'stretch',
  },
  box: {
    transition: 'none',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-start',
    paddingTop: '30px',
    paddingBottom: '14px',
    paddingLeft: '10px',
    paddingRight: '10px',
    marginTop: '60px',
    marginLeft: '40px',
    marginRight: '20px',
    background: 'white',
    boxShadow: '0px 4px 11px rgba(0, 0, 0, 0.12)',
  },
  image: {
    marginTop: '-5px',
    marginRight: '12px',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    ...theme.mundi.font.lato700Normal,
    color: grayMelange,
    fontSize: '14px',
    lineHeight: '16.41px',
  },
  subtitle: {
    ...theme.mundi.font.lato500Normal,
    color: grayMelange,
    fontSize: '13px',
    lineHeight: '15.23px',
  },
  emptyImage: {
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: '60px',
  },
}))

export const PaymentEmpty = ({ onChangeList }) => {
  const translate = useTranslate()
  const classes = useStyles()

  useEffect(() => {
    if (onChangeList) onChangeList({ total: null, loading: false })
    // eslint-disable-next-line
  }, [onChangeList])

  return (
    <div className={classes.emptyPanel}>
      <div className={classes.box}>
        <ErrorImage className={classes.image} />
        <div className={classes.column}>
          <Typography paragraph className={classes.title}>
            {translate(`resources.payments.empty.title`)}
          </Typography>
          <Typography paragraph className={classes.subtitle}>
            {translate(`resources.payments.empty.subtitle`)}
          </Typography>
        </div>
      </div>
      <PaymentEmptyImage className={classes.emptyImage} />
    </div>
  )
}
